export const basketArenaPresentation = {
  colors: {
    background: 0x020611,
    fog: 0x050a18,
    courtWood: '#b96f32',
    courtWoodLight: '#d99a54',
    courtWoodDark: '#7f431f',
    courtPaint: '#102a58',
    courtLine: '#f6ead4',
    cyan: 0x47dff5,
    violet: 0xa477ff,
    amber: 0xffc857,
    rim: 0xff5a1f,
    structure: 0x151c28,
  },
  renderer: { maxPixelRatio: 1.75, exposure: 1.08 },
  court: { width: 32, length: 42, centerZ: -4.5, textureSize: 1024 },
  crowd: { columns: 34, rows: 5, spacingX: 0.88, tierRise: 1.05, baseY: 2.15 },
  ambience: { dustCount: 70, ledPulseSpeed: 1.35, ledPulseAmount: 0.22 },
  effects: { swishParticleCount: 28, swishDuration: 0.95, cameraImpulse: 0.075 },
  net: { strands: 16, rings: 5, height: 1.48, topRadius: 0.9, bottomRadius: 0.48 },
} as const;

export const basketAudioPresentation = {
  masterGain: 0.72,
  ambienceGain: 0.018,
  reverbSeconds: 1.15,
  reverbDecay: 2.5,
  swishDuration: 0.34,
  crowdLiftDuration: 0.72,
} as const;
